<mat-form-field class="w-full">
    <mat-label><apcam-translation [model]="inputConfig.label" /></mat-label>
    <mat-select
        [formControlName]="formcontrolName"
        [(value)]="selectedLanguage">
        @if (selectedLanguage) {
            <mat-select-trigger class="pt-2">
                <div class="flex gap-2 items-center">
                    <apcam-flag
                        [altText]="
                            ('shared.selectCountry.flagIcon' | translate) +
                            selectedLanguage
                        "
                        [flagCode]="
                            LocaleService.getFlagCodeFromLanguageCode(
                                selectedLanguage
                            )
                        " />
                    {{ 'shared.languages.' + selectedLanguage | translate }}
                </div>
            </mat-select-trigger>
        }
        @for (language of supportedLanguages(); track language) {
            <mat-option [value]="language">
                <div class="flex gap-2 items-center">
                    <apcam-flag
                        [altText]="
                            ('shared.selectCountry.flagIcon' | translate) +
                            language
                        "
                        [flagCode]="
                            LocaleService.getFlagCodeFromLanguageCode(language)
                        "></apcam-flag>
                    {{ 'shared.languages.' + language | translate }}
                </div>
            </mat-option>
        }
    </mat-select>
    @if (input.hasError('required')) {
        <mat-error>
            {{ 'shared.validation.required' | translate }}
        </mat-error>
    }
</mat-form-field>
